import { call } from 'redux-saga/effects'

/**
 * La selección de filtros para el catálogo se realiza desde la UI usando
 * `CatalogoContext.filterChange`.
 *
 * Saga "no-op" mantenida por paridad con la arquitectura existente.
 */
export function* filtrosMotoSaga() {
  yield call(() => undefined)
}

export default filtrosMotoSaga
